import { TFunction } from 'react-i18next';

import { SnackbarPayload } from 'theSource/components';

export const gerErrorSnackbar = (t: TFunction): SnackbarPayload => ({
  message: t('messages.login:invalidCredentials'),
  position: 'bottom',
  severity: 'error',
});

export const getLocalLanguage = () => {
  return localStorage.getItem('preferred_language') &&
    localStorage.getItem('preferred_language') !== null
    ? localStorage.getItem('preferred_language')
    : 'en';
};
